import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-26d6f263"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "d-flex fl-col fl-a-c fl-s-b"
};
var _hoisted_2 = {
  class: "upper-text-label"
};
var _hoisted_3 = {
  class: "lower-text-label"
};
var _hoisted_4 = {
  class: "d-flex fl-col fl-a-c fl-s-b"
};
var _hoisted_5 = {
  class: "upper-text-label"
};
var _hoisted_6 = {
  class: "lower-text-label"
};
var _hoisted_7 = {
  class: "d-flex fl-col fl-a-c fl-s-b"
};
var _hoisted_8 = {
  class: "upper-text-label"
};
var _hoisted_9 = {
  class: "lower-text-label"
};

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "vertical"
  }, null, -1);
});

var _hoisted_11 = {
  class: "d-flex fl-col fl-a-c fl-s-b"
};
var _hoisted_12 = {
  class: "upper-text-label"
};
var _hoisted_13 = {
  class: "lower-text-label print-all"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_el_col = _resolveComponent("el-col");

  var _component_el_row = _resolveComponent("el-row");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.modalVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return _ctx.modalVisible = $event;
    }),
    "show-close": false,
    "close-on-click-modal": false,
    width: _ctx.showPrintLabelButton ? '700px' : '540px'
  }, {
    title: _withCtx(function () {
      return [_createVNode(_component_el_row, {
        gutter: 35,
        class: "title-wrapper"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 1
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_SvgIcon, {
                iconContent: _ctx.iconContent,
                iconAlt: _ctx.iconAlt,
                iconStyle: _ctx.iconStyle
              }, null, 8, ["iconContent", "iconAlt", "iconStyle"])];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            class: "title-text",
            span: 6
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString("".concat(_ctx.$t("completeorder.print"))), 1)];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    default: _withCtx(function () {
      return [_createVNode(_component_el_row, {
        class: "d-flex fl-j-c"
      }, {
        default: _withCtx(function () {
          return [_ctx.showPrintTicketButton ? (_openBlock(), _createBlock(_component_el_col, {
            key: 0,
            span: _ctx.showPrintLabelButton ? 6 : 8
          }, {
            default: _withCtx(function () {
              return [_ctx.printTicketLoading ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: "spinner only-buttons buttons",
                loading: true
              })) : (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                onClick: _cache[0] || (_cache[0] = function ($event) {
                  return _ctx.printTickets2();
                }),
                class: "only-buttons buttons"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("completeorder.only")), 1), _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("completeorder.tickets")), 1)])];
                }),
                _: 1
              }))];
            }),
            _: 1
          }, 8, ["span"])) : _createCommentVNode("", true), _createVNode(_component_el_col, {
            span: _ctx.showPrintLabelButton ? 6 : 8
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                onClick: _ctx.componentPrintReceipt,
                class: "only-buttons buttons"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("completeorder.only")), 1), _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("completeorder.receipts")), 1)])];
                }),
                _: 1
              }, 8, ["onClick"])];
            }),
            _: 1
          }, 8, ["span"]), _ctx.showPrintLabelButton ? (_openBlock(), _createBlock(_component_el_col, {
            key: 1,
            span: 6
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                onClick: _cache[1] || (_cache[1] = function ($event) {
                  return _ctx.printLabels();
                }),
                class: "only-buttons buttons"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("completeorder.only")), 1), _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("completeorder.labels")), 1)])];
                }),
                _: 1
              })];
            }),
            _: 1
          })) : _createCommentVNode("", true), _ctx.showPrintTicketButton || _ctx.showPrintLabelButton ? (_openBlock(), _createBlock(_component_el_col, {
            key: 2,
            span: 1
          }, {
            default: _withCtx(function () {
              return [_hoisted_10];
            }),
            _: 1
          })) : _createCommentVNode("", true), _ctx.showPrintTicketButton || _ctx.showPrintLabelButton ? (_openBlock(), _createBlock(_component_el_col, {
            key: 3,
            span: _ctx.showPrintLabelButton ? 5 : 7
          }, {
            default: _withCtx(function () {
              return [_ctx.showPrintTicketButton && _ctx.printTicketLoading ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: "spinner only-buttons buttons",
                loading: true
              })) : (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                onClick: _ctx.printAll,
                class: "both-buttons buttons"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("completeorder.print")), 1), _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("completeorder.all")), 1)])];
                }),
                _: 1
              }, 8, ["onClick"]))];
            }),
            _: 1
          }, 8, ["span"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            onClick: _ctx.closeModal,
            class: "cancel-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)];
            }),
            _: 1
          }, 8, ["onClick"])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue", "width"]);
}